import GroupRequestsRoute from "discourse/routes/group/requests";
import { i18n } from "discourse-i18n";

export default class CircleRequestsRoute extends GroupRequestsRoute {
  titleToken() {
    return i18n("discourse_circles.circle.requests.title_token", {
      circle_name: this.modelFor("circle").name,
    });
  }

  model(params) {
    this._params = params; // inherited from GroupRequestsRoute

    return this.modelFor("circle").member_group;
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.circleModel = this.modelFor("circle");
  }
}
